export default "__VITE_ASSET__DNdD_LMq__"